import { createStore } from 'vuex';
import cartHelpers from './api';
const { status, fetch,fetchExtraData, add, update, change, updateNote, clear } = cartHelpers;
const req = (api, data) => {
  return new Promise(resolve => {
    api(data).then(data => {
      resolve(data);
    });
  });
};

const afterReq = (data, commit, getters) => {
  commit('setCart', data);

  const _status = getters.cartItems.length ? status.ideal : status.empty;
  commit('setStatus', _status);
};


export default createStore({
  state: {
    cart: {},
    extraData: [],
    status: status.empty,
    updateIds: [],
    updateLine: 0,
  },

  getters: {
    isCartReady: state => [status.ideal, status.empty].includes(state.status),
    cartItems: state => state.cart.items || []
  },

  mutations: {
    setCart(state, cart) {
      state.cart = cart;
    },

    addCartItem(state, items) {
      state.cart.items.splice(0, 0, ...items);
    },

    setExtraData(state, extraData) {
      state.extraData = extraData
    },

    setUpdateIds(state, ids) {
      state.updateIds = ids;
    },

    setStatus(state, status) {
      state.status = status;
    },
    
    setUpdateLine(state, lines) {
      state.updateLine = lines;
    },
  },

  actions: {
    async init({ commit, getters }, s1 = status.progress) {
      await commit('setStatus', s1);
      await req(fetchExtraData).then(extraData => commit('setExtraData', extraData));
      await req(fetch).then(data => afterReq(data, commit, getters));
      return true;
    },

    async initReplo({ commit, getters }, s1 = status.adding) {
      await commit('setStatus', s1);
      await req(fetchExtraData).then(extraData => commit('setExtraData', extraData));
      await req(fetch).then(data => afterReq(data, commit, getters));
      return true;
    },

    async add({ commit, dispatch, getters }, data) {
      if (getters.isCartReady) {
        await commit('setStatus', status.adding);
        await req(add, data).then(async() => await dispatch('init', status.adding));
        return true;
      }
    },

    async change({ commit, getters }, data) {
      const { noStateUpdate, cb } = data
      delete data.cb
      if (getters.isCartReady || noStateUpdate) {
        if(!noStateUpdate) {
          await commit('setUpdateLine', data.line);
          await commit('setStatus', status.progress);
        }else delete data.noStateUpdate
        
        await req(change, data).then(async data => {
         await  afterReq(data, commit, getters);
          !noStateUpdate && await commit('setUpdateLine', 0);
          cb && cb()
        });
        return true;
      }
    },

    async update({ commit,dispatch, getters }, data) {
      if (getters.isCartReady) {
        await commit('setUpdateLine', data.line);
        await commit('setStatus', status.progress);
        await req(update, data.data).then(async () => {
          await dispatch('init', status.progess);
        });
        return true;
      }
    },

    updateNote({ commit, getters }, note) {
      if (getters.isCartReady) {
        commit('setStatus', status.progress);
        req(updateNote, note).then(data => afterReq(data, commit, getters));
      }
    },

    clear({ commit, getters }) {
      if (getters.isCartReady) {
        commit('setStatus', status.progress);
        req(clear).then(data => afterReq(data, commit, getters));
      }
    }
  }
});